import {Decimal} from 'decimal.js';
import ImageUtils from '../../lib/ImageUtils';
import valWithinBounds from './ValWithinBounds';

export function initZoomImageData({imageSize, rect, selectedImage, zoom}) {
    const rectRatio = Decimal.div(rect.width, rect.height);

    // Guard: zero image dimensions (image not yet loaded) — return neutral zero-offset state
    if (!imageSize || imageSize.width <= 0 || imageSize.height <= 0) {
        return {
            relativeViewSize: { width: 0, height: 0 },
            zoomedInView: { width: 0, height: 0 },
            offsets: { x: 0, y: 0, zoom, minX: 0, maxX: 0, minY: 0, maxY: 0 },
        };
    }

    const imageRatio = Decimal.div(imageSize.width, imageSize.height);

    const relativeViewSize = imageRatio.gt(rectRatio)
        ? {
            // Landscape image: constrain by height, crop sides
            width: Decimal.mul(imageSize.height, rectRatio).round().toNumber(),
            height: imageSize.height,
        }
        : {
            // Portrait image: constrain by width, crop top/bottom
            width: imageSize.width,
            height: Decimal.div(imageSize.width, rectRatio).round().toNumber(),
        };

    const zoomedInView = ImageUtils.zoomedInSize(relativeViewSize, zoom);

    const xDiff = imageSize.width - zoomedInView.width;
    const minX = xDiff > 0 ? 0 : xDiff;
    const maxX = xDiff > 0 ? xDiff : 0;

    const yDiff = imageSize.height - zoomedInView.height;
    const minY = yDiff > 0 ? 0 : yDiff;
    const maxY = yDiff > 0 ? yDiff : 0;

    const centeredX = xDiff > 0 ? Math.round(xDiff / 2) : 0;
    const centeredY = yDiff > 0 ? Math.round(yDiff / 2) : 0;
    const rawX = selectedImage.x ?? centeredX;
    const rawY = selectedImage.y ?? centeredY;
    const x = valWithinBounds(rawX, minX, maxX);
    const y = valWithinBounds(rawY, minY, maxY);

    return {
        relativeViewSize,
        zoomedInView,
        offsets: {
            x,
            y,
            zoom,
            minX,
            maxX,
            minY,
            maxY,
        },
    };
}
